import React from "react";

const Compensatory = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
    <path className="u_fill"
          d="M14.562 13.749h-3.438c-.073-3.1 1.174-5.84 3.184-7.762l-2.38-.71a.626.626 0 00-.467.044L5.813 8.265v-.453a.937.937 0 00-.937-.937H2.937A.937.937 0 002 7.812v12.185c0 .518.42.938.937.938h1.939c.517 0 .937-.42.937-.938v-1.25h8.749c1.387 0 2.5-1.138 2.5-2.499 0-1.378-1.122-2.5-2.5-2.5zM23.424 27.683l-1.051 1.05V24.37a.937.937 0 10-1.875 0v4.364l-1.051-1.052a.937.937 0 00-1.326 1.326l2.652 2.651a.938.938 0 001.325 0l2.651-2.65a.937.937 0 10-1.325-1.326zM33.305 23.613a.938.938 0 00-1.148.663l-.385 1.435-2.182-3.779a.937.937 0 00-1.623.937l2.182 3.78-1.436-.385a.938.938 0 00-.485 1.81l3.621.971a.937.937 0 001.148-.663l.97-3.621a.937.937 0 00-.662-1.148zM14.16 26.264l-1.436.384 2.182-3.779a.937.937 0 10-1.624-.937l-2.182 3.78-.384-1.437a.938.938 0 00-1.811.486l.97 3.621a.937.937 0 001.148.663l3.622-.97a.937.937 0 00-.486-1.811z"
          fill={fill}
    />
    <path className="u_fill"
          d="M21.435 5c-4.118 0-7.555 2.966-8.29 6.874h1.417a4.38 4.38 0 014.374 4.374 4.38 4.38 0 01-2.532 3.966 8.37 8.37 0 005.031 1.658c4.652 0 8.436-3.784 8.436-8.436S26.087 5 21.435 5zm.901 12.065v.08a.937.937 0 01-1.874 0v-.007a3.563 3.563 0 01-1.102-.462.937.937 0 011.027-1.568c.37.242 1.003.338 1.301.197.197-.092.348-.29.37-.478.044-.403-.6-.632-.975-.78-.583-.23-1.308-.517-1.73-1.278-.599-1.083-.076-2.511 1.109-3.003v-.04a.937.937 0 011.873-.022c.332.105.639.271.884.498a.937.937 0 01-1.271 1.378c-.147-.136-.617-.192-.813-.06-.13.087-.186.26-.141.341.193.348 1.22.473 1.994 1.076 1.586 1.236 1.046 3.471-.652 4.128z"
          fill={fill}
    />
    </svg>
);

export default Compensatory;